import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../../services/auth.service';
import { filter } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { SharedService } from '../../../shared/services/shared.service';
import { RoutesPath } from '../../../shared/constants/routes-path';


@Component({
  standalone: true,
  selector: 'app-login-callback',
  imports: [TranslateModule],
  templateUrl: './login-callback.component.html',
  styleUrl: './login-callback.component.scss'
})
export class LoginCallbackComponent implements OnInit {
  userLoginFailed: boolean = false;

  // This method is used to initialize the class instance using auth service, router, oauth service, and route
  constructor(
    public authService: AuthService,
    private router: Router,
    private oauthService: OAuthService,
    private route: ActivatedRoute,
    private sharedService: SharedService
  ) {
    const queryParams = this.route.snapshot.queryParams;
    if (!queryParams || (Object.keys(queryParams).length === 0)) {
      this.userLoginFailed = true;
      return;
    }

  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit() {
    this.oauthService.events
      .pipe(
        filter((e: OAuthEvent) => e.type === 'token_received')
      )
      .subscribe(() => {
        const claims: any = this.authService.getUserClaims();
        const idToken: any = this.authService.getIdToken();
        const accessToken: any = this.authService.getAccessToken();
        if (claims) {
          localStorage.setItem('login_user', JSON.stringify({ user: claims, token: idToken, access_token: accessToken }));
          localStorage.removeItem('primaryAccount');
          this.sharedService.clearUserProfile();
          this.navigateAfterLogin();

        } else {
          this.goToLogin();
        }
      });

    // Error events (like login failure)
    this.oauthService.events
      .pipe(filter((e: OAuthEvent) => e.type === 'token_error' || e.type === 'code_error'))
      .subscribe((e: any) => {
        this.userLoginFailed = true;
      });

    // In case tokens are already present (e.g. reload)   
    if (this.authService.isLoggedIn() && this.authService.getUserClaims()) {
      const claims: any = this.authService.getUserClaims();
      const idToken: any = this.authService.getIdToken();
       const accessToken: any = this.authService.getAccessToken();
       localStorage.setItem('login_user', JSON.stringify({ user: claims, token: idToken, access_token: accessToken }));
     this.navigateAfterLogin();
    }
  }

  private navigateAfterLogin() {
    const redirectUrl = this.authService.consumeRedirectUrl();
    const targetUrl = redirectUrl && redirectUrl !== '/login-callback'
      ? redirectUrl
      : `/${RoutesPath.DASHBOARD}`;
    this.router.navigateByUrl(targetUrl, { replaceUrl: true });
  }

  // This method is used to go to login
  goToLogin() {
    this.router.navigate(["/login"])
  }
}

